﻿import buttonLoader from "../utilities/buttonLoader.js";

const courseRegister = {
	init: function () {
		const container = document.querySelector(".courseRegister__container")
			? document.querySelector(".courseRegister__container")
			: null;

		if (container && !container.dataset.courseRegisterInitialized) {
			container.dataset.courseRegisterInitialized = "true";
			this.bind(container);
			this.handleValidation(container);
		}
	},

	handleValidation: (container) => {
		const form = container.querySelector(".courseRegisterForm");
		const submitButton = form ? form.querySelector("[data-id='paymentSubmit']") : null;

		if (!form || !submitButton) return;

		const fields = form.querySelectorAll("input, select, textarea");
		let isSubmitting = false;

		const getErrorMessage = (field) => {
			if (field.validity.valueMissing) {
				return "Þessi reitur er nauðsynlegur.";
			}
			if (field.validity.patternMismatch) {
				switch (field.id) {
					case "customerSSN":
						return "Kennitala er ekki rétt skráð.";
					case "customerEmail":
						return "Vinsamlegast sláðu inn gilt netfang.";
					case "customerName":
						return "Vinsamlegast sláðu inn gilt nafn.";
					default:
						return "Gildi passar ekki við skilyrði.";
				}
			}
			return "Ógilt gildi.";
		};

		const showError = (field) => {
			const errorFor = field.type === "radio" ? field.name : field.id;
			const errorMessage = form.querySelector(`[data-error-for="${errorFor}"]`);
			if (!errorMessage) return;

			errorMessage.textContent = getErrorMessage(field);
			field.classList.add("invalid");
		};

		const clearError = (field) => {
			const errorFor = field.type === "radio" ? field.name : field.id;
			const errorMessage = form.querySelector(`[data-error-for="${errorFor}"]`);
			if (errorMessage) errorMessage.textContent = "";
			field.classList.remove("invalid");
		};

		const updateSubmitButton = () => {
			if (!isSubmitting) {
				submitButton.disabled = !form.checkValidity();
			}
		};

		// Validate fields
		fields.forEach((field) => {
			const validateField = () => {
				field.checkValidity() ? clearError(field) : showError(field);
			};

			field.addEventListener("input", validateField);
			field.addEventListener("change", validateField);
		});

		form.addEventListener("submit", (e) => {
			if (isSubmitting) {
				e.preventDefault();
				return;
			}

			let hasErrors = false;

			fields.forEach((field) => {
				if (!field.checkValidity()) {
					showError(field);
					hasErrors = true;
				} else {
					clearError(field);
				}
			});

			if (hasErrors) {
				e.preventDefault();
			} else {
				isSubmitting = true;
				submitButton.disabled = true;
				buttonLoader.start(submitButton);
			}
		});

		form.addEventListener("input", updateSubmitButton);
		form.addEventListener("change", updateSubmitButton);
		updateSubmitButton();
	},

	bind: (container) => {
		const step1 = container.querySelector(".courseRegister__step1");
		const step2 = container.querySelector(".courseRegister__step2");
		const nextStep = container.querySelector("#nextStep");
		const radiomarks = container.getElementsByClassName("radiomark");
		const choice1 = container.querySelector("#choice1");
		const choice2 = container.querySelector("#choice2");

		if (!step1 || !step2 || !nextStep || !choice1 || !choice2) return;

		Array.prototype.forEach.call(radiomarks, (radiolisten) => {
			radiolisten.addEventListener("click", () => {
				Array.prototype.forEach.call(radiomarks, (radio) => {
					nextStep.removeAttribute("disabled");
					radio.classList.remove("validation--error");
				});
			});
		});

		if (nextStep) {
			nextStep.addEventListener("click", (e) => {
				e.preventDefault();

				if (choice1.checked) {
					step1.classList.add("is-hidden");
					step2.classList.remove("is-hidden");

					step2.classList.add("courseRegister__step2--single");
				} else if (choice2.checked) {
					step1.classList.add("is-hidden");
					step2.classList.remove("is-hidden");

					step2.classList.remove("courseRegister__step2--single");
				} else if (!choice1.checked && !choice2.checked) {
					Array.prototype.forEach.call(radiomarks, (radiomark) => {
						radiomark.classList.add("validation--error");
					});
				}
			});
		}
	},
};

courseRegister.initialize = () => {
	courseRegister.init();
};

module.exports = courseRegister;
